// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'shuffle';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M14.88 7.593 17 5.296 14.88 3' />
    <path d='M1 12.778h4.855c1.162 0 2.051-1.037 2.051-2.223V7.592c0-1.259.957-2.296 2.12-2.296H17M14.88 15 17 12.704l-2.12-2.297' />
    <path d='M17 12.704h-6.974c-1.163 0-2.12-1.037-2.12-2.296V7.445c0-1.26-.889-2.223-2.051-2.223H1' />
  </g>
);

export const viewBox = '0 0 18 18';
